import { OAUTH_REDIRECT_URL } from '@/features/auth/login/consts/oauth';
import type { Strategy } from '@/features/auth/login/types/login';
import type { useSignIn, useSignUp } from '@clerk/clerk-react';

type SignInResource = ReturnType<typeof useSignIn>['signIn'];
type SignUpResource = ReturnType<typeof useSignUp>['signUp'];

export const initiateOAuthRedirect = async (
  resource: SignInResource | SignUpResource,
  strategy: Strategy
): Promise<void> => {
  if (!resource) {
    throw new Error('Authentication resource not available');
  }

  await resource.authenticateWithRedirect({
    strategy,
    redirectUrl: OAUTH_REDIRECT_URL,
    redirectUrlComplete: '/'
  });
};
